"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "ComponentList", {
  enumerable: true,
  get: function get() {
    return _componentList.ComponentList;
  }
});
Object.defineProperty(exports, "DisplayBoard", {
  enumerable: true,
  get: function get() {
    return _displayBoard.DisplayBoard;
  }
});
Object.defineProperty(exports, "PropertyBoard", {
  enumerable: true,
  get: function get() {
    return _propertyBoard.PropertyBoard;
  }
});
Object.defineProperty(exports, "JsonTable", {
  enumerable: true,
  get: function get() {
    return _jsonTable.JsonTable;
  }
});
Object.defineProperty(exports, "baseComponents", {
  enumerable: true,
  get: function get() {
    return _baseComponents.baseComponents;
  }
});
Object.defineProperty(exports, "advanceComponents", {
  enumerable: true,
  get: function get() {
    return _advanceComponents.advanceComponents;
  }
});
Object.defineProperty(exports, "FieldType", {
  enumerable: true,
  get: function get() {
    return _fieldType.FieldType;
  }
});
Object.defineProperty(exports, "FormView", {
  enumerable: true,
  get: function get() {
    return _formView.FormView;
  }
});
Object.defineProperty(exports, "FormModal", {
  enumerable: true,
  get: function get() {
    return _formModal.FormModal;
  }
});
Object.defineProperty(exports, "AdvanceFilter", {
  enumerable: true,
  get: function get() {
    return _advanceFilter.AdvanceFilter;
  }
});
Object.defineProperty(exports, "ShowCols", {
  enumerable: true,
  get: function get() {
    return _showCols.ShowCols;
  }
});
Object.defineProperty(exports, "JsonView", {
  enumerable: true,
  get: function get() {
    return _vueJsonView.JsonView;
  }
});
Object.defineProperty(exports, "Utils", {
  enumerable: true,
  get: function get() {
    return _vueJsonView.Utils;
  }
});
Object.defineProperty(exports, "FormProperty", {
  enumerable: true,
  get: function get() {
    return _formProperty.FormProperty;
  }
});
Object.defineProperty(exports, "FormApi", {
  enumerable: true,
  get: function get() {
    return _formApi.FormApi;
  }
});
Object.defineProperty(exports, "transformLang", {
  enumerable: true,
  get: function get() {
    return _transformLang.transformLang;
  }
});
Object.defineProperty(exports, "filterFormItems", {
  enumerable: true,
  get: function get() {
    return _jsonComponent.filterFormItems;
  }
});
Object.defineProperty(exports, "JsonComponent", {
  enumerable: true,
  get: function get() {
    return _jsonComponent.JsonComponent;
  }
});
exports.XlsxUtils = exports.JsonViewMaker = void 0;

var _vue = _interopRequireDefault(require("vue"));

var _stores = require("./stores");

var _componentList = require("./componentList");

var _displayBoard = require("./displayBoard");

var _propertyBoard = require("./propertyBoard");

var _jsonTable = require("./jsonTable/jsonTable");

var _baseComponents = require("./baseComponents");

var _advanceComponents = require("./advanceComponents");

var _fieldType = require("./fieldType");

var _formView = require("./formView");

var _formModal = require("./formModal");

var _advanceFilter = require("./jsonTable/advanceFilter");

var _showCols = require("./jsonTable/showCols");

var _vueJsonView = require("vue-json-view");

require("./style/index.less");

var _locale = require("./locale");

var _formProperty = require("./formProperty");

var _http = require("./utils/http");

var _formApi = require("./apis/formApi");

var _linkForm = require("./linkForm");

var _linkApi = require("./utils/linkApi");

var XlsxUtils = _interopRequireWildcard(require("./utils/xlsx"));

exports.XlsxUtils = XlsxUtils;

var _transformLang = require("./utils/transformLang");

var _linkTable = require("./linkTable");

var _jsonComponent = require("./common/jsonComponent");

var _dragChildContainer = require("./dragChildContainer");

var JsonViewMaker = {
  install: function install(vue) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var http = options.http;

    if (!http) {}

    (0, _http.setHttp)(http);

    if (options.fileDomain) {
      (0, _http.setFileDomain)(options.fileDomain);
    }

    vue.use(_vueJsonView.VueJsonView);

    _vue.default.component('mh-component-list', _componentList.ComponentList);

    _vue.default.component('mh-display-board', _displayBoard.DisplayBoard);

    _vue.default.component('mh-property-board', _propertyBoard.PropertyBoard);

    _vue.default.component('mh-form-property', _formProperty.FormProperty);

    _vue.default.component('mh-json-table', _jsonTable.JsonTable);

    _vue.default.component('mh-form-view', _formView.FormView);

    _vue.default.component('mh-form-modal', _formModal.FormModal);

    _vue.default.component('mh-json-view', _vueJsonView.JsonView);

    _vue.default.component('mh-link-form', _linkForm.LinkForm);

    _vue.default.component('mh-link-table', _linkTable.LinkTable);

    _vue.default.component('drag-child-container', _dragChildContainer.DragChildContainer);
  },
  use: function use(mod) {
    if (mod && mod.setHttp) {
      (0, _http.setHttpListener)(mod.setHttp);
    }

    if (mod && mod.setFileDomain) {
      (0, _http.setFileDomainListener)(mod.setFileDomain);
    }
  },
  reset: function reset() {
    return _stores.store.reset();
  },
  getJson: function getJson() {
    return _stores.store.getJson();
  },
  setJson: function setJson(json) {
    return _stores.store.setJson(json);
  },
  setLang: function setLang(lang) {
    return (0, _locale.setLang)(lang);
  },
  json2View: _vueJsonView.VueJsonView.json2View,
  ele2VNode: _vueJsonView.VueJsonView.ele2VNode,
  addTransChain: _vueJsonView.VueJsonView.addTransChain,
  setActionFunc: _vueJsonView.VueJsonView.setActionFunc,
  addFormula: _vueJsonView.VueJsonView.addFormula,
  linkApi: _linkApi.linkApi,
  setHttpMethod: _http.setHttpMethod
};
exports.JsonViewMaker = JsonViewMaker;